import Journey from '@models/Journey'

export default function createOjpJourneys({ bookings, journeys, direction }) {
  const { id: bookingId } = bookings[0]
  const journeyDirection = direction === 'outward' ? 'outward' : 'return'

  if (journeys.length) {
    const updatedJourneys = journeys.map((journey) => {
      return {
        ...journey,
        direction: journeyDirection,
      }
    })

    Journey.insert({
      data: [...updatedJourneys],
    }).then(({ journeys }) => {
      const ojpResponseJourneys = Journey.query()
        .whereIdIn(journeys.map((journey) => journey.id))
        .withAll()
        .all()

      Journey.insert({
        data: {
          direction: journeyDirection,
          booking_id: bookingId,
          journey_planner_response: ojpResponseJourneys,
        },
      })
    })
  }
}
